module.exports = {
  series: [
    "resume-parser",
    "resume-editor",
    "alex",
    "abilities",
    "market",
    "coach",
    "videowiki-cast",
    "videowiki-room",
  ],
  flow: {
    "resume-parser": {
      purpose: "Resume Parser",
      steps: [
        {
          id: "uploadAndSync",
          title: "Upload and Sync",
          desc: "Upload your resume document to parse with our AI and review the result and sync with the editor.",
          url: "/parser",
        },
      ],
    },
    "resume-editor": {
      purpose: "Resume Editor",
      steps: [
        {
          id: "about",
          title: "About",
          desc: "Your basic introduction goes here.",
          url: "https://editor.getboarded.com/oauth-callback?organization=${orgSlug}&token=${token}&userId=${userId}&redirectTo=about",
        },
        {
          id: "extraCurricular",
          title: "Skills",
          desc: "Add your tech skills and showcase your soft skills that give a persona to your profile.",
          url: "https://editor.getboarded.com/oauth-callback?organization=${orgSlug}&token=${token}&userId=${userId}&redirectTo=skills",
        },
        {
          id: "contact",
          title: "Contact",
          desc: "Basic contact data on resume includes location (address), contact, phone number, email address and social-links . ",
          url: "https://editor.getboarded.com/oauth-callback?organization=${orgSlug}&token=${token}&userId=${userId}&redirectTo=contact",
        },
        {
          id: "careerHistory",
          title: "Career History",
          desc: "Career History with information about your previous job roles, including your current role if employed",
          url: "https://editor.getboarded.com/oauth-callback?organization=${orgSlug}&token=${token}&userId=${userId}&redirectTo=career-history",
        },
        {
          id: "educationalQualification",
          title: "Educational Qualifications",
          desc: "List all your relevant school and academic training you have gained including high school and university degrees. Always start with your highest educational achievement, or current studies, and highlight courses that will interest the reader",
          url: "https://editor.getboarded.com/oauth-callback?organization=${orgSlug}&token=${token}&userId=${userId}&redirectTo=educational-qualifications",
        },
        {
          id: "project",
          title: "Projects",
          desc: "Based on the skills describe the projects you have completed, showcase them and get your resume a weight.",
          url: "https://editor.getboarded.com/oauth-callback?organization=${orgSlug}&token=${token}&userId=${userId}&redirectTo=projects",
        },
      ],
    },
    abilities: {
      purpose: "Career Lab",
      steps: [
        {
          id: "selfAssessment",
          title: "Self-Assessment with positively enforced ranking",
          desc: " Your abilities that you think you are best and most known for.",
          url: "https://abilities.getboarded.com/oauth-callback?token=${token}&gborgid=${orgId}#self-assessment",
        },
        {
          id: "selfPriority",
          title: "Set personal development priorities",
          desc: " Set development priority on the ability that is most needed for you to be successful in your current context.",
          url: "https://abilities.getboarded.com/oauth-callback?token=${token}&gborgid=${orgId}#self-priority",
        },
        {
          id: "advisorReviews",
          title: "360° review from advisors",
          desc: "Build your advisor circle to get a view of how other see your abilities.",
          url: "https://abilities.getboarded.com/oauth-callback?token=${token}&gborgid=${orgId}#advisor-reviews",
        },
        {
          id: "talentReport",
          title: "Generate Talent Report",
          desc: "Build your talent strength report to get insights into your true abilities, by comparing how you see yourself and how others see you.",
          url: "https://abilities.getboarded.com/oauth-callback?token=${token}&gborgid=${orgId}#talent-report",
        },
      ],
    },
    alex: {
      purpose: "Library",
      steps: [
        {
          id: "skillSet",
          title: "Enter your skill set",
          desc: "News and interest based items will be activated as a feed in the development charter. These are just industry awareness content based on your interest and expertise.",
          url: "https://library.getboarded.com/oauth-callback?token=${token}&org={orgSlug}&gbuid=${userId}&gborgid=${orgId}&redirectTo=skills",
        },
        {
          id: "activate-bot",
          title: "Activate Bot",
          desc: "Receive periodic recommendations to your mail as per your configured modality, format and schedule.",
          url: "https://library.getboarded.com/oauth-callback?token=${token}&org={orgSlug}&gbuid=${userId}&gborgid=${orgId}#activate-bot",
        },
        {
          id: "distributeItems",
          title: " Distribute a course",
          desc: "",
          url: "https://library.getboarded.com/oauth-callback?token=${token}&org={orgSlug}&gbuid=${userId}&gborgid=${orgId}",
        },
      ],
    },
    market: {
      purpose: "Market",
      steps: [
        {
          id: "activateWallet",
          title: "Wallet active",
          desc: "Wallet is activated and has a redeemable currency",
          url: "/user/wallet",
        },
        {
          id: "pickReward",
          title: "Pick reward",
          desc: "Browse organizational markets and select items to redeem with your wallet balance. Select item and place an order.",
          url: "https://market.getboarded.com/${orgSlug}?userId=${userId}&authToken=${token}",
        },
      ],
    },
    "videowiki-cast": {
      purpose: "VideoWiki Cast",
      steps: [
        {
          id: "quickCast",
          title: "Quick Cast",
          desc: "Run a quick cast with Video.Wiki and invite attendees from the board. Publish the event now or schedule it for later with email reminders notification as per your cast timing.",
          url: "https://decast.live/oauth-callback?token=${token}&board_id=${boardId}&redirect_to=https://decast.live/dashboard/casts/create#quick-cast",
        },
        {
          id: "basicCast",
          title: "Basic Cast",
          desc: "",
          url: "https://decast.live/oauth-callback?token=${token}&board_id=${boardId}&redirect_to=https://decast.live/dashboard/casts/create#quick-cast",
        },
        {
          id: "brandedCast",
          title: "Branded Cast",
          desc: "",
          url: "https://decast.live/oauth-callback?token=${token}&board_id=${boardId}&redirect_to=https://decast.live/dashboard/casts/create#branded-cast",
        },
        {
          id: "advancedCast",
          title: "Advanced Cast",
          desc: "For running Live and NFT drop casts schedule it on Video.Wiki and enter the cast URL here.",
          url: "https://decast.live/oauth-callback?token=${token}&board_id=${boardId}&redirect_to=https://decast.live/dashboard/casts/create#advanced-cast",
        },
        {
          id: "joincast",
          title: "Join Casts",
          desc: "The current active cast by clicking here or on the live button on the board.",
        },
      ],
    },
    "videowiki-room": {
      purpose: "VideoWiki Room",
      steps: [
        {
          id: "createRoom",
          title: "Start your room",
          desc: "These are your private video rooms to invite collaborators and work together by taking notes, running opinion polls, sharing presentations or videos to watch in sync.",
          url: "https://decast.live/oauth-callback?token=${token}&board_id=${boardId}&redirect_to=https://decast.live/dashboard/rooms/create",
        },
        {
          id: "joinRoom",
          title: "Join Rooms",
          desc: "Join the current active room by clicking here or on the live button on the board.",
        },
      ],
    },
    coach: {
      purpose: "Mentor",
      // steps: {
      //   coach: {
      //     steps: [
      //       {
      //         id: "playerProgress",
      //         title: "Player Progress",
      //         desc: "People who you are coaching to be successful on a similar career journey to yours.",
      //         // desc: '"N" players assigned to you. People who you are coaching to be successful on a similar career journey to yours.',
      //         customUrl:
      //           "https://coach.getboarded.com/user/trainee-details/view",
      //         magicLink: true,
      //       },
      //       {
      //         id: "trainingCenter",
      //         title: "Resource Library",
      //         desc: "Resource library with training content for your sessions. Share presentations, videos and books for self-development.",
      //         customUrl:
      //           "https://coach.getboarded.com/user/training-center/view",
      //         magicLink: true,
      //       },
      //     ],
      //   },
      //   trainee: {
      //     steps: [
      //       {
      //         id: "goalSettingSession",
      //         title: "Set a goal",
      //         desc: "Set your context of skill development by defining your role and what it will mean to be successful.",
      //         customUrl: "https://gtbrdd.typeform.com/to/sAvguKab",
      //         magicLink: true,
      //       },
      //       {
      //         id: "mentorAssignment",
      //         title: "Meet your mentor",
      //         desc: "A guide is assigned to you for the program. Someone who is further than you in a similar career journey.",
      //         customUrl:
      //           "https://coach.getboarded.com/user/my-coach/profile/view",
      //         magicLink: true,
      //       },
      //       {
      //         id: "developmentPlan",
      //         title: "Set Development Actions",
      //         desc: "Pick an ability and an associated behaviour to develop and set your development plan.",
      //         customUrl: "https://coach.getboarded.com/user/add-skill",
      //         magicLink: true,
      //       },
      //       // {
      //       //   id: "todoItemsSet",
      //       //   title: "ToDo Items Set",
      //       //   desc: `Mark items that you want to build into your habits and close them to "done" once you have tuned them into your character.`,
      //       //   customUrl: "https://coach.getboarded.com/user/home",
      //       //   magicLink: true,
      //       // },
      //       {
      //         id: "inviteAdvisors",
      //         title: "Invite Advisors",
      //         desc: "Invite the people who you feel are great at demonstrating the ability you want to develop and who could observe and give feedback on your progress.",
      //         customUrl:
      //           "https://coach.getboarded.com/user/my-rater/rater-list",
      //         magicLink: true,
      //       },
      //       {
      //         id: "motivationFeedback",
      //         title: "Motivation Feedback",
      //         desc: "Keep a log of your motivation to build consistency. Turn motivated behaviour into consistent habits and those habits into a credible character.",
      //         customUrl: "https://coach.getboarded.com/user/home",
      //         magicLink: true,
      //       },
      //       // {
      //       //   id: "goalComplete",
      //       //   title: "Goal Complete",
      //       //   desc: "Mark your development goal complete when you are satisfied yourself and have enough advisors assuring that you are demonstrating abilities to the best of your potential.",
      //       //   customUrl: "https://coach.getboarded.com/user/home",
      //       //   magicLink: true,
      //       // },
      //       {
      //         id: "coachingReview",
      //         title: "Coaching Review",
      //         desc: "Review your coaching experience with a periodic survey to check individual, team and leadership alignment to your goals.",
      //         customUrl:
      //           "https://coach.getboarded.com/user/coaching-experience",
      //         magicLink: true,
      //       },
      //     ],
      //   },
      // },
      steps: [
        {
          id: "goalSettingSession",
          title: "Set a goal",
          desc: "Set your context of skill development by defining your role and what it will mean to be successful.",
          customUrl: "https://gtbrdd.typeform.com/to/sAvguKab",
          magicLink: true,
        },
        {
          id: "mentorAssignment",
          title: "Meet your mentor",
          desc: "A guide is assigned to you for the program. Someone who is further than you in a similar career journey.",
          customUrl: "https://coach.getboarded.com/user/my-coach/profile/view",
          magicLink: true,
        },
        {
          id: "developmentPlan",
          title: "Set Development Actions",
          desc: "Pick an ability and an associated behaviour to develop and set your development plan.",
          customUrl: "https://coach.getboarded.com/user/add-skill",
          magicLink: true,
        },
        {
          id: "inviteAdvisors",
          title: "Invite Advisors",
          desc: "Invite the people who you feel are great at demonstrating the ability you want to develop and who could observe and give feedback on your progress.",
          customUrl: "https://coach.getboarded.com/user/my-rater/rater-list",
          magicLink: true,
        },
        {
          id: "motivationFeedback",
          title: "Motivation Survey",
          desc: "Keep a log of your motivation to build consistency. Turn motivated behaviour into consistent habits and those habits into a credible character.",
          customUrl: "https://coach.getboarded.com/user/home",
          magicLink: true,
        },
        {
          id: "coachingReview",
          title: "Coaching Review",
          desc: "Review your coaching experience with a periodic survey to check individual, team and leadership alignment to your goals.",
          customUrl: "https://coach.getboarded.com/user/coaching-experience",
          magicLink: true,
        },
      ],
    },
  },
};
